// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {FormInput} from './../../../mixins/form_input/FormInput'

@Component({
    name: 'Textarea',
    mixins: [
        template,
    ]
})
export class Textarea extends mixins(FormInput) {

    public get themeMap() {
        const themeMap = {
            default: 1,
            secondary: 2
        }

        return themeMap[this.theme] ? themeMap[this.theme] : themeMap['default']
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get textareaClass() {
        return `wb-e-inp-${this.themeMap}`
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0 ? `${this.$appPrefix}-textarea--error wb-e-inp-${this.themeMap}--has-error` : ''
    }

    @Prop()
    public theme!: string

    @Prop([String, Number])
    public value!: any

    @Prop()
    public label!: string

    @Prop()
    public placeholder!: string

    @Prop()
    public info!: string

    @Prop()
    public maxlength!: number

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop()
    public cols!: number

    @Prop({default: 3})
    public rows!: number

    @Prop({default: false})
    public disabled!: boolean

    @Prop()
    public id!: string

    @Prop()
    public name!: string

    @Prop({default: true})
    public showErrors!: boolean

    @Prop({default: false})
    public readonly!: boolean

    @Prop({default: "0"})
    public tabindex!: string

    public created () {

    }

    public mounted() {

    }

    public destroyed() {

    }

    public handleChange(value: any) {
        this.$emit('input', value)
    }

    public handleBlur(value: any) {
        this.$emit('blur', value)
    }
}